import AddIcon from '@mui/icons-material/Add';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import RemoveIcon from '@mui/icons-material/Remove';
import { useTheme } from "@mui/material/styles";


const SentimentIcon = ({ type }) => {
    const theme = useTheme();
    const styles = {
        positive: { color: theme.palette.success.main },
        negative: { color: theme.palette.error.main },
        neutral: { color: theme.palette.text.secondary }
    };

    switch (type) {
        case 'positive':
            return <AddIcon sx={styles.positive} />;
        case 'negative':
            return <RemoveIcon sx={styles.negative} />;
        case 'neutral':
            return <DragHandleIcon sx={styles.neutral} />;
        default:
            return null;
    }
}

export default SentimentIcon;